angular.module('HomepageServices', [
	'x1.ui.select',
	'x1.ui.tabs',
	'ngFileUpload',
	'matchmedia-ng',
	'pascalprecht.translate',
	'ShellServices',
	'ui.router',
	'homepage.contentUI.tabs'
]);

require('./common/i18nConfig');
require('./common/assetUploadService');
require('./common/searchTransformerService');
require('./common/tenantRegistryService');
require('./common/userProfileService');
require('./common/services');
require('./common/tabs');

require('./components/mainContainer');
require('./components/widget');
require('./components/addAssets');
require('./components/addUser');
require('./components/createContent');
require('./components/hubUsage');
require('./components/search');

require('./components/addUser');
require('./components/publishingAtAGlance');
require('./components/downloadSite');
require('./components/shutterstockImage');
require('./components/shutterstockFootage');





// WEBPACK FOOTER //
// ./app/app.module.js